<template>
  <div class="dc-login">
    <b-container>
      <b-row>
        <b-col sm="12" md="6" lg="4" offset-lg="1">
          <div class="h5 black mb-4">Inserisci il Buono e prenota il tuo viaggio</div>
          <p>Troverai lo sconto disponibile al momento del pagamento</p>
          <ul class="ml-3 pb-3">
            <li>
              Se il Buono ha un valore inferiore al conto finale dovrai saldare la differenza con
              carta di credito. Non potrai pagare la differenza con il tuo credito welfare.
            </li>
            <li>
              Se il Buono ha un valore superiore all'ammontare del pagamento, potrai utilizzare il
              valore residuo per una futura prenotazione. Riceverai una email di riepilogo.
            </li>
            <li>All'interno potrai caricare altri Buoni in tuo possesso e cumulare lo sconto.</li>
          </ul>
        </b-col>
        <b-col sm="12" md="6" lg="4" offset-lg="1">
          <div class="h5 black mb-4">Inserisci il Codice sconto</div>
          <validation-observer v-slot="{ invalid }">
            <validation-provider
              rules="required|alpha_num|min:16|max:16"
              name="Codice sconto"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>Codice sconto</label>
                <b-input
                  v-model="discount_code"
                  autocomplete="chrome-off"
                  placeholder="Es: XXXXXXXXXXXXXXXX"
                />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
            <validation-provider
              rules="required|alpha_spaces|min:2"
              name="Nome"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>Nome</label>
                <b-input v-model="name" autocomplete="chrome-off" placeholder="Nome" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
            <validation-provider rules="alpha_spaces|min:2" name="Cognome" v-slot="{ errors }">
              <div class="form-group">
                <label>Cognome</label>
                <b-input v-model="surname" autocomplete="chrome-off" placeholder="Cognome" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
            <validation-provider rules="required|email" name="Email" v-slot="{ errors }">
              <div class="form-group">
                <label>Email</label>
                <b-input v-model="email" autocomplete="chrome-off" placeholder="Email" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <div class="mt-3">
              <validation-provider
                :rules="{ required: { allowFalse: false } }"
                name="Condizioni d'uso"
                v-slot="{ errors }"
              >
                <div class="form-group--checkbox">
                  <label>
                    <router-link :to="{ name: 'terms' }" target="_blank" class="nounderline">
                      <span class="secondary">Accetto le condizioni d'uso</span>
                    </router-link>
                  </label>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="checkbox_terms"
                      id="checkbox_terms"
                    />
                    <label class="custom-control-label" for="checkbox_terms"></label>
                  </div>
                  <span class="vee--errors">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                :rules="{ required: { allowFalse: false } }"
                name="Privacy"
                v-slot="{ errors }"
              >
                <div class="form-group--checkbox">
                  <label>
                    <router-link
                      :to="{ name: 'privacy-policy' }"
                      target="_blank"
                      class="nounderline"
                    >
                      <span class="secondary">Accetto le condizioni di Privacy</span>
                    </router-link>
                  </label>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="checkbox_privacy"
                      id="checkbox_privacy"
                    />
                    <label class="custom-control-label" for="checkbox_privacy"></label>
                  </div>
                  <span class="vee--errors">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>

            <div class="mt-2">
              <div class="loginButton" v-if="!loading">
                <b-button block v-if="recaptcha_enabled" :disabled="invalid" @click="recaptcha"
                  >CARICA</b-button
                >
                <b-button block v-else :disabled="invalid" @click="dc_login_handler"
                  >CARICA</b-button
                >
              </div>
              <Spinner v-else />
            </div>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { dc_login } from '@/api';
import Spinner from '@/components/atoms/spinner';

export default {
  name: 'dc-sso',
  components: {
    Spinner,
  },
  props: {
    discount_code_url: {
      type: String,
      default: '',
    },
    name_url: {
      type: String,
      default: '',
    },
    surname_url: {
      type: String,
      default: '',
    },
    email_url: {
      type: String,
      default: '',
    },
  },
  created() {
    this.dc_login = dc_login;
  },
  data() {
    return {
      loading: false,
      name: '',
      surname: '',
      email: '',
      discount_code: '',
      checkbox_terms: false,
      checkbox_privacy: false,
      recaptcha_enabled: Vue.prototype.$config.recaptcha.enabled,
      recaptcha_token: '',
    };
  },
  mounted() {
    if (Vue.prototype.$config.recaptcha.enabled) {
      Vue.use(VueReCaptcha, {
        siteKey: Vue.prototype.$config.recaptcha.siteKey,
      });
    }
    // http://localhost:8666/ho-un-buono/Dgbtc04hv4mjAxJy/giuseppe/cardamone/test@email.it/ --> OCCHIO: trailing slash obbligatorio!
    if (this.discount_code_url !== '') {
      this.discount_code = this.discount_code_url;
    }
    if (this.name_url !== '') {
      this.name = this.name_url;
    }
    if (this.surname_url !== '') {
      this.surname = this.surname_url;
    }
    if (this.email_url !== '') {
      this.email = this.email_url;
    }
  },
  methods: {
    async recaptcha() {
      this.loading = true;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('login');
      this.recaptcha_token = token;
      this.dc_login_handler();
    },
    dc_login_handler() {
      this.loading = true;
      this.dc_login({
        discountCode: this.discount_code,
        name: this.name,
        surname: this.surname,
        email: this.email,
        recaptcha: this.recaptcha_token,
      }).then(
        (success) => {
          if (success.data && success.data.token) {
            window.location.href = '/?token=' + success.data.token;
          } else {
            this.loading = false;
          }
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style lang="scss">
.dc-login {
  margin-top: 2 * $grid-gutter-width;
  @include media-breakpoint-up(sm) {
    margin-top: 4 * $grid-gutter-width;
  }
  .form-group--checkbox {
    @extend .form-grouè !optional;
    display: flex;
    flex-wrap: wrap;
    label {
      order: 2;
    }
    input {
      order: 1;
    }
    .vee--errors {
      display: block;
      width: 100%;
      order: 3;
      margin-top: 0;
    }
  }
}
</style>
